module.exports = __webpack_public_path__ + "static/media/pr-7.81357183.jpeg";